export default "__VITE_ASSET__f6b78004__"